export default function socialShareButtons () {
  $('.fb').click(function () {
    let opt = 'width=800,height=500,left=200,top=300,menubar=no,status=no,location=no'
    let url = encodeURIComponent($(this).data('url') || '')
    window.open('https://facebook.com/sharer/sharer.php?u=' + url, 'popup', opt)
    return false
  });
  $('.tw').click(function () {
    let opt = 'width=600,height=300,left=200,top=300,menubar=no,status=no,location=no'
    let text = encodeURIComponent($(this).data('text') || '')
    window.open('https://twitter.com/intent/tweet?text=' + text, 'popup', opt)
    return false
  });
}



// WEBPACK FOOTER //
// ./app/webpack/packs/javascripts/shared/social_share_buttons.js